import PolicyEntity from './PolicyEntity'

export default PolicyEntity
